<div class="card">
    <div class="card-header">
        <h5>Merchant/Agent Questions List</h5>
    </div>
</div>
<div class="row mt-4" *ngFor="let question of questionList; let i = index">
    <div *ngIf="question.subQuestion.length != 0">
        <div class="form-group col-md-10">
            <h5>{{i+1}}. {{question.question}}</h5>
        </div>
        <div class="row d-flex" *ngFor="let subQuestionData of question.subQuestion; let j = index">
            <div class="d-flex">
                <div class="form-group col-md-10">
                    <p>{{alpha[j]}}. {{subQuestionData.question}}</p>
                </div>
                <div class="form-group col-md-1" >
                    <input class="form-check-input" type="radio"  name="nshRadio{{alpha[j]+subQuestionData.id}}" value="yes" autocomplete="off" (change)="subQuestionYesClick(alpha[j]+subQuestionData.id,subQuestionData.id,subQuestionData.parentQuestionId,i)">
                    <label class=" col-form-label form-check-label" style="margin-left: 5px;  margin-top: -5px;"> Yes</label>
                </div>
                <div class="form-group col-md-1" >
                    <input class="form-check-input" type="radio"  name="nshRadio{{alpha[j]+subQuestionData.id}}" value="no" autocomplete="off" (change)="subQuestionNoClick(alpha[j]+subQuestionData.id,subQuestionData.id,subQuestionData.parentQuestionId,i)">
                    <label class=" col-form-label form-check-label" style="margin-left: 5px; margin-top: -5px;"> No</label>
                </div>
            </div>
        </div>
        <div class="form-group col-md-12" *ngIf="question.isTextField">
            <!-- <label class="col-form-label">{{question.description}}</label> -->
            <textarea class="form-control" rows="3" name="description{{i}}" [placeholder]="question.description" id="{{question.id}}" maxlength="200"></textarea>
        </div>
        <div class="form-group col-md-12" *ngIf="question.error">
            <p style="color: red;">Please fill the description details</p>
        </div>
    </div>
    <div *ngIf="question.subQuestion.length == 0">
            <div class="d-flex">
                <div class="form-group col-md-10">
                    <h5>{{i+1}}. {{question.question}}</h5>
                </div>
                <div class="form-group col-md-1" >
                    <input class="form-check-input" type="radio"  name="nshRadio{{alpha[i]+question.id}}" value="yes" autocomplete="off" (change)="questionYesClick(alpha[i]+question.id,question.id,i)">
                    <!-- <input class="form-check-input" type="radio"  (change)="yesCheckBox($event,i)"> -->
                    <label class=" col-form-label form-check-label"  style="margin-left: 5px; margin-top: -5px;" > Yes</label>
                </div>
                <div class="form-group col-md-1" >
                    <input class="form-check-input" type="radio"  name="nshRadio{{alpha[i]+question.id}}" value="no" autocomplete="off" (change)="questionNoClick(alpha[i]+question.id,question.id,i)">
                    <!-- <input class="form-check-input" type="radio"  (change)="noCheckBox($event,i)"> -->
                    <label class=" col-form-label form-check-label"  style="margin-left: 5px; margin-top: -5px;"> No</label>
                </div>
            </div>
            <div class="form-group col-md-12" *ngIf="question.isTextField">
                <!-- <label class="col-form-label">{{question.description}}</label> -->
                <textarea class="form-control" rows="3" name="description{{i}}" [placeholder]="question.description" id="{{question.id}}" maxlength="200"></textarea>
            </div>
            <div class="form-group col-md-12" *ngIf="question.error">
                <p style="color: red;">Please fill the description details</p>
            </div>
    </div>
    <br>
    <hr>
</div>
<button class="btn btn-primary" type="button" (click)="submitFinal()">Submit</button>
<!-- <progress *ngIf="showProgressBar" [value]="progress" max="100"></progress> -->


<!-- <form [formGroup]="myForm">
    <div formArrayName="emailList">
        <div *ngFor="let email of emailList.controls; let i=index">
            <input [formControlName]="i">
            <button type="button" (click)="removeEmail(i)">
                Remove
            </button>
        </div>
        <button type="button" (click)="addEmail()">
            Add Email
        </button>
    </div>
</form> -->
